<template>
  <FormItem v-bind="$attrs" ref="formItemRef" :class="{ 'pg-form-item__notlabel': !label }">
    <template #label>
      <span
        v-if="!!label"
        :style="labelStyle"
        :class="{ 'pg-form-item-label__drag': dragHandle === '.pg-form-item-label__drag' }"
        >{{ label }}</span
      >
      <template v-if="labelTip && !!label">
        <Popover
          class="pg-form-item-tip"
          popper-class="pg-form-item-tip__popper"
          trigger="hover"
          placement="right"
          :content="labelTip"
          width="200"
        >
          <template #reference>
            <span>?</span>
          </template>
        </Popover>
      </template>
    </template>
    <slot></slot>
  </FormItem>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { FormItem, Popover } from 'element-ui'
import { useFormItemValidateProvide } from '../hook/use-form-item-validate'
defineProps({
  label: String,
  labelTip: String,
  dragHandle: String,
  labelStyle: Object,
})

const { formItemRef, formItemsChange } = useFormItemValidateProvide()
defineExpose({
  formItemsChange,
})
</script>
<style lang="scss">
@import '../style/form-item.scss';
</style>
